import { useTranslation } from 'react-i18next';

import { Button, Form, Input, Modal, Space } from '@arco-design/web-react';
import { IconPlus } from '@arco-design/web-react/icon';
import { useEffect, useState } from 'react';
import { PermissionModal } from './permission';

const FormItem = Form.Item;

interface Props {
  module: 'platform' | 'cluster' | 'console' | 'system';
  roleMap: any;
  onOk: (data: any) => void;
  onCancel?: () => void;
}
export function CreateRole({ roleMap, module, onOk }: Props) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (visible) {
      form.resetFields();
    }
  }, [visible]);

  const onOk1 = async (data) => {
    try {
      await form.validate();
      const roleName = form.getFieldValue('name');
      await onOk({ roleName, data, type: 'create' });
      setVisible(false);
      setShow(false);
    } catch (e) {
      console.log(e, '创建角色失败');
    }
  };

  return (
    <>
      <Modal
        visible={visible}
        closable={false}
        style={{ width: 500 }}
        title={<div style={{ textAlign: 'left' }}>{t('cluster:create-role')}</div>}
        footer={
          <Space>
            <Button onClick={() => setVisible(false)}>{t('common:cancel')}</Button>
            <Button
              type="primary"
              onClick={async () => {
                try {
                  await form.validate();
                  setShow(true);
                } catch (e) {}
              }}
            >
              {t('components:permission.configuration')}
            </Button>
          </Space>
        }
        onCancel={() => setVisible(false)}
      >
        {visible && (
          <Form form={form} autoComplete="off" layout="vertical">
            <FormItem
              label={t('common:name')}
              field="name"
              required
              rules={[{ required: true, message: t('components:please.enter.role.name') }]}
            >
              <Input placeholder={t('components:please.enter.role.name')} />
            </FormItem>
          </Form>
        )}
      </Modal>
      <PermissionModal roleMap={roleMap} show={show} onOk={onOk1} onCancel={() => setShow(false)} />
      <Button
        icon={<IconPlus />}
        type="primary"
        className="btnStyle"
        onClick={() => setVisible(true)}
      >
        {t('cluster:create-role')}
      </Button>
    </>
  );
}
